export const frontmatter = {
    "draft": false,
    "title": "Configuración del sistema",
    "description": "Configuración general del sistema OnnIA.",
    "sidebar_label": "Configuración del sistema",
    "sidebar_group": "referencia",
    "sidebar_order": 5
}

export const toc = []